import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../types'
import { CmsConverterService, defaultLinkData } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CentralizedButtonConverter extends CmsConverterService<CentralizedButtonData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      bgColor: formData.st_backgroundcolor?.value?.identifier ?? '',
      padding: formData.st_padding_top?.value?.identifier ?? '',
      link: formData.st_url ?? defaultLinkData
    }
  }
}

export const CENTRALIZED_BUTTON_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CentralizedButtonData>>('CentralizedButtonConverter')

export interface CentralizedButtonData extends ConvertedComponentData {
  padding: string;
  bgColor: string;
  link: LinkData;
}
